import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { ActionIcon, useMantineTheme } from '@mantine/core';
import { PredefinedIcons } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.types';

interface Props {
	iconVariant?: PredefinedIcons;
	onClick?: (e: React.MouseEvent) => void;
	dataTestId?: string;
	customIcon?: React.ReactNode;
}

export const ActionIconButton = ({ iconVariant, onClick, dataTestId, customIcon }: Props) => {
	const theme = useMantineTheme();

	return (
		<ActionIcon
			variant="transparent"
			size="lg"
			onClick={onClick}
			sx={{ '&:hover': { color: theme.colors.blue[6] } }}
			data-testid={dataTestId}
			c="dark.0"
			color="dark.0"
		>
			{customIcon ?? (iconVariant && <Icon variant={iconVariant} size="vlg" />)}
		</ActionIcon>
	);
};
